import { BaseWebComponentElement } from '../../../../../../framework/BaseWebComponentElement';
import { GzSearchablePolicyPanelController } from '../controller/GzSearchablePolicyPanelController';
import { PolicyContext } from '../../../redux/navigationHeaderSlice/types.navigation';
import { store } from '@nirvana/redux/store';
import { setActiveView } from '@nirvana/redux/searchable-ui-accordions';

/**
 * This component will be used to manage the searchable policy panel when add/edit policy will be fully implemented with web components.
 * For now, only works with mock data.
 */
export class GzSearchablePolicyPanelWebComponent extends BaseWebComponentElement {
  public controller: GzSearchablePolicyPanelController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: GzSearchablePolicyPanelController,
    });
  }

  set routingPath(baseRoute: string) {
    this.setAttribute('routing-path', baseRoute);
  }

  get routingPath(): string {
    return this.getAttribute('routing-path') || '';
  }

  set policyId(policyId: string) {
    this.setAttribute('policy-id', policyId);
  }

  get policyId(): string {
    return this.getAttribute('policy-id') || '';
  }

  set context(context: PolicyContext) {
    this.setAttribute('policy-context', context);
  }

  get context(): PolicyContext {
    return this.getAttribute('policy-context') as PolicyContext;
  }

  public setActiveView(activeView: string) {
    store.dispatch(setActiveView(activeView));
  }
}
